import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as PacksNotSavedChangesActions from './packs-not-saved-changes.actions';
import * as PacksNotSavedChangesSelectors from './packs-not-saved-changes.selectors';
import { forkJoin, Observable, take } from 'rxjs';
import { PackNotSavedChangesEntity } from './packs-not-saved-changes.reducer';
import { BOMModel } from '@cpak/adp-cpak-quotes-service-models';
import { BOMPageData } from '@cpak/interfaces';

@Injectable()
export class PacksNotSavedChangesFacade {
  private readonly maximumNotSavedPacks = 100;

  constructor(private readonly store: Store) {}

  public addBOMChangesToStore(
    packId: string,
    packData: Partial<BOMPageData>,
    changedProducts: string[],
    bom: BOMModel
  ): void {
    forkJoin([
      this.store.pipe(select(PacksNotSavedChangesSelectors.getPacksNotSavedChangesEntities())).pipe(take(1)),
      this.store.pipe(select(PacksNotSavedChangesSelectors.getPacksNotSavedChangesTotal())).pipe(take(1)),
    ]).subscribe(([entities, total]) => {
      if (entities && !entities[packId] && total >= this.maximumNotSavedPacks) {
        const firstPackId = Object.keys(entities)[0];
        this.clearChangesForPack(firstPackId);
      }
    });
    this.store.dispatch(
      PacksNotSavedChangesActions.updateNotSavedBOMForPack({ packId, packData, changedProducts, bom })
    );
  }

  public clearAllChanges(): void {
    this.store.dispatch(PacksNotSavedChangesActions.removeNotSavedChangesForAllPacks());
  }

  public clearChangesForPack(packId: string): void {
    this.store.dispatch(PacksNotSavedChangesActions.removeNotSavedChangesForPack({ packId }));
  }

  public getPackChanges(packId: string): Observable<PackNotSavedChangesEntity | undefined> {
    return this.store.pipe(select(PacksNotSavedChangesSelectors.getNotSavedChangesForPak(packId)));
  }
}
